const BASEDIR = "../";

const INFO = {
	main: {
		title: "Emmanuel Mmanda | Software Engineer",
		name: "Emmanuel Mmanda",
		email: "luneya17@gmail.com",
		logo: BASEDIR + "avatar.png",
	},

	socials: {
		twitter: "https://twitter.com/immaginativetz",
		github: "https://github.com/EmmanuelMmanda",
		linkedin: "https://www.linkedin.com/in/emmanuel-mmanda-4a727524b/",
		instagram: "https://instagram.com/hourlycodez",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
		whatsapp:
			"https://wa.me/+255627472950/?text=Hello Emmanuel, Lets connect.",
	},

	homepage: {
		title: "I'm a Software Engineer",
		description:
			"I build production-ready APIs, integrations, and digital products for real operational needs. My work spans JavaScript and React, Python and Django, PHP and Laravel, USSD and SMS platforms, payment infrastructure, cloud deployment, and Linux systems. I am also developing practical AI expertise to add intelligent workflows without compromising reliability, security, or user trust.",
	},

	about: {
		title: "I’m Emmanuel Mmanda, a Software Engineer based in Tanzania.",
		description:
			"I design and build dependable software for real operational needs. My experience includes backend APIs, USSD and SMS services, payment integrations, cloud-hosted systems, server administration, and interfaces that help people get work done. I am especially interested in practical AI integration: using intelligent workflows to improve products, automate repetitive work, and help teams make better decisions while keeping systems understandable and trustworthy.",
	},

	articles: {
			title: "Notes from building useful software",
		description:
				"Field notes on APIs, offline-first products, USSD services, cloud systems, and practical AI integration—grounded in the work behind my portfolio.",
	},

	projects: [
		{
			title: "OdaBook",
			description:
				"A bilingual, offline-tolerant point-of-sale and business workspace for Tanzanian traders. OdaBook brings sales, barcode checkout, orders, purchasing, stock, customers, suppliers, receipts, and staff permissions into one dependable mobile workflow.",
			logo: BASEDIR + "assets/odabook-icon.png",
			imageFit: "contain",
			linkText: "Discuss Project",
			link: "/contact",
			tags: ["software / ", "platform / ", "services / "],
			categories: ["Products", "Web Applications"],
		},

		{
			title: "SokoHuru",
			description:
				"A Smart DSE Investing Platform that helps users follow the Dar es Salaam Stock Exchange and make more informed investment decisions.",
			logo: BASEDIR + "assets/sokohuru.jpg",
			linkText: "Discuss Project",
			link: "/contact",
			tags: ["marketplace / ", "web / ", "product / "],
			categories: ["Products", "Web Applications"],
		},

		{
			title: "Afya Maoni",
			description:
				"A health-focused feedback and communication concept designed to help collect and organize community insights.",
			logo: BASEDIR + "assets/tanzania-emblem.png",
			imageFit: "contain",
			linkText: "Discuss Project",
			link: "/contact",
			tags: ["health / ", "feedback / ", "communication / "],
			categories: ["Products", "Health", "Communication"],
		},
		{
			title: "VICOBA USSD Services",
			description:
				"An integrated USSD and SMS platform for Village Community Banks, with APIs, payments, communication services, and cloud deployment.",
			logo: BASEDIR + "assets/main-menu.jpg",
			linkText: "Read Case Study",
			link: "/article/1",
			tags: ["django / ", "DRF / ", "USSD / ", "SMS / "],
			categories: ["Backend & APIs", "Communication", "Financial Services"],
		},

		{
			title: "Engineering Work Across Domains",
			description:
				"Generalized experience across fleet management systems, CRMs and contact centers, backend services, and AI integration.",
			logo: BASEDIR + "assets/enterprise-systems.jpg",
			linkText: "Discuss Project",
			link: "/contact",
			tags: ["fleet / ", "CRM / ", "contact center / ", "AI / "],
			categories: ["Enterprise Systems", "AI Integration"],
		},
		{
			title: "Tanzania Geo-Data API",
			description: "A Django REST API for regions, districts, wards, and streets in mainland Tanzania, paired with a React interface.",
			logo: "https://i.imgur.com/4aBDglJ.png",
			linkText: "View on GitHub",
			link: "https://github.com/EmmanuelMmanda/Tanzania-GeoLocation-API-for-regions--districts-and-wards",
			tags: ["Python / ", "Django / ", "DRF / ", "React / "],
			categories: ["Backend & APIs", "Web Applications"],
		},
		{
			title: "USSD and SMS Voting System",
			description: "A Django REST Framework implementation of a voting workflow integrated with USSD and SMS through Africa's Talking.",
			logo: "https://i.imgur.com/fvO3DKF.png",
			linkText: "View on GitHub",
			link: "https://github.com/EmmanuelMmanda/USSD-and-SMS-Voting-System--DRF-API",
			tags: ["Africa's Talking / ", "Django / ", "DRF / ", "GCP / "],
			categories: ["Backend & APIs", "Communication"],
		},
		{
			title: "Foody React App",
			description: "A React and Firebase food-ordering application exploring Context, Hooks, and component-driven product flows.",
			logo: "https://raw.githubusercontent.com/EmmanuelMmanda/A-Food-Ordering-Web-Application-Using-React-Js--/main/src/Assets/food%20order.png",
			linkText: "View on GitHub",
			link: "https://github.com/EmmanuelMmanda/A-Food-Ordering-Web-Application-Using-React-Js--",
			tags: ["React / ", "Firebase / ", "GitHub Pages / "],
			categories: ["Web Applications", "Frontend"],
		},
		{
			title: "DHIS2 Todo App",
			description: "A React/Vite interface integrating with the HISP DHIS2 API, deployed on DigitalOcean.",
			logo: "https://i.imgur.com/gVFXdZX.png",
			linkText: "View on GitHub",
			link: "https://github.com/EmmanuelMmanda/hisp-todo-teaser",
			tags: ["Vite / ", "React / ", "DigitalOcean / "],
			categories: ["Frontend", "Backend & APIs"],
		},
		{
			title: "Herbal Information System",
			description: "A PHP information system connecting patients with traditional medicine providers.",
			logo: "https://raw.githubusercontent.com/EmmanuelMmanda/PHP-Herbal-Information-System/master/images/git.PNG",
			linkText: "View on GitHub",
			link: "https://github.com/EmmanuelMmanda/PHP-Herbal-Information-System",
			tags: ["PHP / ", "Health / "],
			categories: ["Health", "Web Applications"],
		},
		{
			title: "Maternal Information System",
			description: "A PHP maternity information system with SMS integration for tracking care during the maternity period.",
			logo: "https://raw.githubusercontent.com/EmmanuelMmanda/Maternity-System-with-SMS-API-Intergration/master/maternalsgit.PNG",
			linkText: "View on GitHub",
			link: "https://github.com/EmmanuelMmanda/Maternity-System-with-SMS-API-Intergration",
			tags: ["PHP / ", "SMS / ", "Beem Africa / "],
			categories: ["Health", "Communication", "Web Applications"],
		},
		{
			title: "Mobile First Design",
			description: "A responsive HTML and CSS interface exploring mobile-first layout, navigation, and light/dark theming.",
			logo: "https://i.imgur.com/dlMHGWS.jpg",
			linkText: "View on GitHub",
			link: "https://github.com/EmmanuelMmanda/mobile-first-design-with-dark-theme-and-sidebar",
			tags: ["HTML / ", "CSS / ", "GitHub Pages / "],
			categories: ["Frontend", "Web Applications"],
		},
	],
	works: [
		{
			logo: "https://i.imgur.com/4gIXRVA.png",
			alt: "work-logo",
			workTitle: "Fléx - CITS",
			workSubtitle: "Fulltime: Software Engineer",
			workDuration: "Sept 2023 - Present",
		},
		{
			logo: "https://i.imgur.com/i50cId4.png",
			alt: "work-logo",
			workTitle: "Fléx - CITS",
			workSubtitle: "Intern: Software Engineer",
			workDuration: "Jul 2023 - Aug 2023",
		},
		{
			logo: "https://i.imgur.com/RqnjF21.jpg",
			alt: "work-logo",
			workTitle: "Ardhi University",
			workSubtitle: "Bsc.Information System Management",
			workDuration: "2020 - Jul 2023",
		},
		{
			logo: BASEDIR + "avatar.png",
			alt: "work-logo",
			workTitle: "Freelance",
			workSubtitle: "Software Development",
			workDuration: "2020 - Present",
		},
	],
};

export default INFO;
